export enum BvTableFeaturesIds {
  executionProjection = 'execution-projection-table',
  planningProjection = 'planning-projection-table',
  execution = 'execution-alerts-table'
}
